import axios from "axios";

export const getTransactionDetails = async (transactionHash) => {
  const { data } = await axios.get(
    `${import.meta.env.VITE_API_BASE_URL}/api/transactions/${transactionHash}`
  );

  return data;
};

export const getArtworkWallet = async (walletId, artworkId) => {
  const { data } = await axios.get(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/api/wallet/${walletId}/artwork/${artworkId}`
  );

  return data;
};

export const getArtworksTransactionsCount = async () => {
  const { data } = await axios.get(
    `${import.meta.env.VITE_API_BASE_URL}/api/artworks`
  );

  return data;
};
